import React, { useState, useEffect } from "react";
import { Grid, Card, Modal, Button, Input } from "@scuf/common";

import TitlePage from "../../components/TitlePage/TitlePage";
import DataPolvo from "../../components/Charts/Bprod/DataPolvo";
import Calcina from "../../components/Charts/Bprod/Calcina";
import BalanceCu from "../../components/Charts/Bprod/BalanceCu";
import BalanceS from "../../components/Charts/Bprod/BalanceS";

import "./BProd.css";

const BProd = () => {
  // const [statePolvo, setStatePolvo] = useState(null)
  const [stateModal, setStateModal] = useState(false);
  const [pPolvoCu, setPPolvoCu] = useState(null);
  const [pPolvoS, setPPolvoS] = useState(null);

  const fDataPolvo = async () => {
    setPPolvoCu((await DataPolvo.getAData())[0].PercPolvoCu);
    setPPolvoS((await DataPolvo.getAData())[0].PercPolvoS);
  };

  /// Polvo valor actual
  useEffect(() => {
    fDataPolvo();
  }, []);

  const fChart = (titulo) => {
    return (
      <>
        {titulo === "DIFERENCIA CALCINA VASOS VS CAMIONES" ? (
          <Calcina
            body={{
              opcion: 991,
              orden: 991,
              ultimo: 991,
              frecuencia: 991,
              periodo: 991,
            }}
            height={240}
            name="DIFERENCIA CALCINA VASOS VS CAMIONES"
          />
        ) : titulo === "BALANCE CU FINO" ? (
          <BalanceCu
            body={{
              opcion: 992,
              orden: 992,
              ultimo: 992,
              frecuencia: 992,
              periodo: 992,
            }}
            height={240}
            name="BALANCE CU FINO"
          />
        ) : (
          <BalanceS
            body={{
              opcion: 993,
              orden: 993,
              ultimo: 993,
              frecuencia: 993,
              periodo: 993,
            }}
            height={240}
            name="BALANCE AZUFRE"
          />
        )}
      </>
    );
  };

  const fGlobal = (titulo) => {
    return (
      <Card>
        <Card.Content
          className="text-center no-padding-left no-padding-right letter"
          style={{
            backgroundColor: "#404040",
            minHeight: "250px",
          }}
        >
          <div className="value-staticts-custom text-white letter mb-2 letter-origin mx-2">
            {titulo}
          </div>
          <Grid className="m-0 p-0">
            <Grid.Row>
              <Grid.Column xsWidth={12} sWidth={12} width={12}>
                {fChart(titulo)}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  const fModify = async () => {
    if (pPolvoCu !== 1 && pPolvoCu !== 0 && pPolvoS !== 1 && pPolvoCu !== 0) {
      await DataPolvo.updateData({ opcion: "bProd", Cu: pPolvoCu, S: pPolvoS });
      await fDataPolvo();
      setStateModal(!stateModal);
    }
  };

  return (
    <div className="minTopPage">
      <Grid className="mx-0 mb-0 p-0">
        <Grid.Row>
          <TitlePage title="BALANCE DE PRODUCCIÓN" />
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12} sWidth={12} xsWidth={12}>
            <div className="spaceAmongDiv1">
              <Card style={{ minHeight: "310px" }}>
                <Card.Header title="PROCESO">
                  <Button
                    type="inline-secondary"
                    onClick={() => setStateModal(true)}
                    content={<i className="fa fa-cogs"></i>}
                    size="small"
                    className="mb-2"
                  />
                </Card.Header>
                <Card.Content>
                  <hr style={{ marginTop: "0px", marginBottom: "15px" }} />
                  <div className="spaceAmongDiv1">
                    <Grid.Row>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal("DIFERENCIA CALCINA VASOS VS CAMIONES")}
                      </Grid.Column>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal("BALANCE CU FINO")}
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                  <div className="spaceAmongDiv1">
                    <Grid.Row>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal("BALANCE AZUFRE")}
                      </Grid.Column>
                      <Grid.Column
                        xsWidth={12}
                        sWidth={12}
                        width={6}
                      ></Grid.Column>
                    </Grid.Row>
                  </div>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
        </Grid.Row>
        {pPolvoCu && pPolvoS && (
          <Modal
            className="modalHeightBProd"
            closeIcon={true}
            onClose={() => setStateModal(!stateModal)}
            open={stateModal}
            closeOnDocumentClick={true}
            size="large"
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                className="input-example mt-4"
                label="Porcentaje de Polvo Cu"
                type="number"
                min={0}
                max={100}
                placeholder="%"
                value={pPolvoCu}
                onChange={(e) => setPPolvoCu(e)}
              />
              <Input
                className="input-example mt-3"
                label="Porcentaje de Polvo S"
                type="number"
                min={0}
                max={100}
                placeholder="%"
                value={pPolvoS}
                onChange={(e) => setPPolvoS(e)}
              />
            </div>

            <Modal.Footer>
              <Button
                type="inline-secondary"
                className="button-smaller"
                content="MODIFICAR"
                onClick={() => fModify()}
              />
            </Modal.Footer>
          </Modal>
        )}
      </Grid>
    </div>
  );
};
export default BProd;
